module.exports = __webpack_public_path__ + "static/media/third_quinco_mental.0224bc94.mp4";